import type { TaxChartClass } from '@prisma/client';

export type ShapeKey =
  | 'rectangle'
  | 'triangle'
  | 'disregarded'
  | 'rhombus'
  | 'oval';

// The BE resolves the class; the FE only maps it to a shape.
export const CLASS_TO_SHAPE: Record<TaxChartClass, ShapeKey> = {
  CORPORATION: 'rectangle',
  PASS_THROUGH: 'triangle',
  DISREGARDED: 'disregarded',
  TRUST: 'rhombus',
  INDIVIDUAL_SOLE_PROPRIETOR: 'oval',
  OTHER_REVIEW: 'oval',
};

// Names the class, not the shape carrying it: the oval carries both
// INDIVIDUAL_SOLE_PROPRIETOR and OTHER_REVIEW, so a shape name here would
// label one of them as the other.
export const CLASS_LABEL: Record<TaxChartClass, string> = {
  CORPORATION: 'Corporation',
  PASS_THROUGH: 'Pass-through',
  DISREGARDED: 'Disregarded',
  TRUST: 'Trust',
  INDIVIDUAL_SOLE_PROPRIETOR: 'Individual or sole proprietor',
  OTHER_REVIEW: 'Other or external',
};

export const SHAPE_LABEL: Record<ShapeKey, string> = {
  rectangle: 'Rectangle',
  triangle: 'Triangle',
  disregarded: 'Oval in rectangle',
  rhombus: 'Rhombus',
  oval: 'Oval',
};

// One row per shape, in the order the legend shows them. The oval is labelled
// for what the shape means, since it stands for more than one class.
export const LEGEND_ROWS: { shape: ShapeKey; label: string }[] = [
  { shape: 'rectangle', label: 'Corporation' },
  { shape: 'triangle', label: 'Pass-through' },
  { shape: 'disregarded', label: 'Disregarded' },
  { shape: 'rhombus', label: 'Trust' },
  { shape: 'oval', label: 'Other or External' },
];
